export type NameParts = { firstName: string; lastName: string };

export function splitFullName(fullName: string): NameParts {
  if (!fullName) {
    return { firstName: '', lastName: '' };
  }
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 1) {
    return { firstName: parts[0], lastName: '' };
  }
  return { firstName: parts[0], lastName: parts.slice(1).join(' ') };
}

export function joinFullName(first: string, last: string): string {
  return [first?.trim(), last?.trim()].filter(Boolean).join(' ').trim();
}
